import { Router } from "@angular/router";
import { Component, OnInit, Input } from "@angular/core";

import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { CoreConfigService } from "@core/services/config.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "app/auth/service";
import { environment } from "environments/environment";

@Component({
  selector: "app-popcustomrestriction",
  templateUrl: "./popcustomrestriction.component.html",
  styleUrls: ["./popcustomrestriction.component.scss"],
})
export class PopcustomrestrictionComponent implements OnInit {
  public environment = environment;
  @Input() data;
  public coreConfig: any;
  private _unsubscribeAll: Subject<any>;

  constructor(
    private _coreConfigService: CoreConfigService,
    public modal: NgbActiveModal,
    private authSrv: AuthenticationService,
    private _router: Router
  ) {
    this._unsubscribeAll = new Subject();
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: false,
        },
        footer: {
          hidden: true,
        },
        menu: {
          hidden: false,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  ngOnInit(): void {
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      this.coreConfig = config;
    });
  }

  deco() {
    this.authSrv.logout();
    localStorage.removeItem("block1");
    localStorage.removeItem("block2");
    this._router.navigate(["/auth/login"]);
  }

  contact() {
    this.authSrv.logout();
    localStorage.removeItem("block1");
    localStorage.removeItem("block2");
    window.location.href = environment.baseUrl + "/fr/contact";
    //this._router.navigate(["/auth/login"]);
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
